import Queriesadmin from "../pages/Admin/Queries"
const Queries = ()=>{
    return <Queriesadmin/>
}

export default Queries